import decode from "jwt-decode";

var token;
export default class RaToolAADService {
  setRaToolToken(myToken) {
    token = myToken;
  }
  getRaToolToken() {
    return token;
  }

  getRaToolRoles() {
    var claims;
    if (token && null !== token) {
      claims = decode(token);
    }

    if (claims && claims.hasOwnProperty("roles")) {
      return claims.roles;
    } else {
      return null;
    }
  }

  isInRole(role) {
    if (this.getRaToolRoles()) {
      for (var i = 0; i < this.getRaToolRoles().length; i++) {
        if (this.getRaToolRoles()[i] === role) return true;
      }
    }
    return false;
  }
}
